import React from "react";
import { Form, Input, Select, message, Switch, Button } from "antd";

import { ObjectId } from "bson";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinusCircle } from "@fortawesome/free-solid-svg-icons";
import { setPensando, setStoreWidgets, store } from "../../../../store";
import { Api } from "../../../../api/configApi";
import Boton from "../../../../components/design/elementos/boton";
import CamposPersonalizados from "./CamposPersonalizados/CamposPersonalizados";

function CrearActualizarWidgetAutoLlenarPdf(props) {
  const { Option } = Select;
  const [loading, setLoading] = React.useState(false);
  const [insertOrUpdate, setInsertOrUpdate] = React.useState("InsertWidgets");
  const [form] = Form.useForm();
  const [selectProveedor, setSelectProveedor] = React.useState();
  const [crearListado, setCrearListado] = React.useState();
  const [listaListadoFad, setListaListadoFad] = React.useState([]);

  const guardarWidget = (values) => {
    
    

    if (values.requisitionObj.requisition.signers) {
      let longitudFirmantes = values.requisitionObj.requisition.signers.length;
      for (let i = 0; i < longitudFirmantes; i++) {
        values.requisitionObj.requisition.signers[i].order = i + 1;
      }

      console.log(values, "valores fad")

      values.tipo = "pdf";
      setPensando(true);
      setLoading(true);
      values.limiteCantidad = +values.limiteCantidad;
      values.limiteWidth = +values.limiteWidth;
      Api("Cuentas", insertOrUpdate, { _id: store.cuentaactiva }, values)
        .then((res) => {
          props.setVisible(false);
          setPensando(false);
          setLoading(false);
          return Api(
            "Cuentas",
            "Get",
            { _id: store.cuentaactiva },
            { widgets: 1 }
          );
        })
        .then((res) => {
          setStoreWidgets(res[0].widgets);
        })
        .catch((err) => {
          console.log(err);
          setPensando(false);
          setLoading(false);
        });
    }
  };

  function obtenerListadosFad() {
    Api(
      "integracionFad",
      "enviarListadostypeFad",
      {},
      {},
      "http://79a6-181-132-3-197.ngrok.io"
    )
      .then((res) => {
        setListaListadoFad(() => [...res.listados]);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function crearListadoFad(nombreListado) {
    Api(
      "integracionFad",
      "crearListado",
      {},
      { nombreListado: nombreListado },
      "http://79a6-181-132-3-197.ngrok.io"
    )
      .then((res) => {
        obtenerListadosFad();
      })
      .catch((err) => {
        console.log(err);
      });
  }

  React.useEffect(() => {
    form.resetFields();
    form.setFieldsValue({ _id: new ObjectId(), dinamico: false });
    console.log("o ses poruajsdhj")
  }, [props.visible]);

  React.useEffect(() => {
    if (props.data) {
      form.setFieldsValue(props.data);
      setInsertOrUpdate("UpdateWidgets");
      setSelectProveedor(props.data.proveedorFirma);
      console.log(props.data, "saludos")
    } else {
      form.setFieldsValue({ _id: new ObjectId(), dinamico: false });
      console.log("por aqui es la cosa..")
    }

    obtenerListadosFad();
  }, [props.data]);

  React.useEffect(() => {}, []);

  return (
    <div>
      <Form form={form} onFinish={guardarWidget} layout="vertical">
        <Form.Item
          label="Nombre"
          name="nombre"
          hasFeedback
          rules={[{ required: true, message: "Ingresa un nombre" }]}
        >
          <Input />
        </Form.Item>
        <Form.Item name="_id" hidden rules={[{ required: true }]}></Form.Item>
        <Form.Item
          name="dinamico"
          hidden
          rules={[{ required: true }]}
        ></Form.Item>

        <Form.Item
          label="Titulo"
          name="titulo"
          hasFeedback
          rules={[{ required: true, message: "Ingresa un titulo" }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Descripción"
          name="descripcion"
          hasFeedback
          rules={[{ required: true, message: "Ingresa una descripción" }]}
        >
          <Input />
        </Form.Item>
        {/* select */}
        <Form.Item
          label="Tipo"
          name="tipoPdf"
          hasFeedback
          rules={[{ required: true, message: "Ingresa un tipo" }]}
        >
          <Select>
            <Option value="visual">Visualizar</Option>
            <Option value="autocompletar">Auto completar y visualizar</Option>
          </Select>
        </Form.Item>
        {
          <>
            <Form.Item
              noStyle
              shouldUpdate={(prevValues, currentValues) =>
                prevValues.tipoPdf !== currentValues.tipoPdf
              }
            >
              {({ getFieldValue }) => {
                return (
                  getFieldValue("tipoPdf") === "autocompletar" && (
                    <>
                      <Form.Item
                        label="Formulario"
                        name="formulario"
                        hasFeedback
                        rules={[
                          { required: true, message: "Selecciona una opción" },
                        ]}
                      >
                        <Select>
                          {store.cuenta.formularios.map((formulario) => (
                            <Option value={formulario._id}>
                              {formulario.nombre}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                      <Form.Item
                        noStyle
                        shouldUpdate={(prevValues, currentValues) =>
                          prevValues.formulario !== currentValues.formulario
                        }
                      >
                        {({ getFieldValue }) => {
                          return (
                            store.cuenta.formularios.find(
                              (e) => e._id === getFieldValue("formulario")
                            ) && (
                              <>
                                <Form.Item
                                  label="Campos"
                                  name="campos"
                                  hasFeedback
                                  rules={[
                                    {
                                      required: true,
                                      message: "Ingresa una url",
                                    },
                                  ]}
                                >
                                  <Select mode="multiple">
                                    {store.cuenta.formularios
                                      .find(
                                        (e) =>
                                          e._id === getFieldValue("formulario")
                                      )
                                      .campos.map((e) => (
                                        <Option value={e.name}>{e.name}</Option>
                                      ))}
                                  </Select>
                                </Form.Item>
                                <Form.Item
                                  label="Comportamiento espacios en blanco"
                                  name="relleno"
                                  hasFeedback
                                  rules={[
                                    {
                                      required: true,
                                      message: "Selecciona una opción",
                                    },
                                  ]}
                                >
                                  <Select>
                                    <Option value=" ">
                                      Dejar espacios en blanco
                                    </Option>
                                    <Option value="--------------------------------------------------------------">
                                      Rellenar los espacios con -------
                                    </Option>
                                  </Select>
                                </Form.Item>
                              </>
                            )
                          );
                        }}
                      </Form.Item>
                    </>
                  )
                );
              }}
            </Form.Item>
          </>
        }

        <Form.Item
          label="Ingresa la URL del PDF"
          name="url"
          hasFeedback
          rules={[{ required: true, message: "Ingresa la url del pdf" }]}
        >
          <Input type="url" />
        </Form.Item>

        <Form.Item
          label="Selecciona el listado donde quieres almacenar el estado de la firma"
          name="selectListadoFirma"
          rules={[{ required: true, message: "Selecciona una opción" }]}
        >
          <Select
            showSearch
            placeholder="Selecciona un listado"
            onChange={(e) => {
              setCrearListado(e);
            }}
          >
            {listaListadoFad?.map((listado, index) => {
              return (
                <Option key={listado + index} value={listado.nombre}>
                  {listado.nombre}
                </Option>
              );
            })}

            <Option value="crear">Crear nuevo listado</Option>
          </Select>
        </Form.Item>

        {crearListado === "crear" && (
          <>
            <Form.Item
              name="nombreNuevoListado"
              label="Nombre del nuevo listado"
              rules={[{ required: true, message: "Ingresa un nombre" }]}
            >
              <Input style={{ marginBottom: "20px" }}></Input>
            </Form.Item>
            <Button
              style={{ marginBottom: "15px" }}
              onClick={() => {
                if (form.getFieldsValue().nombreNuevoListado) {
                  setCrearListado(null);
                  form.setFieldsValue({ selectListadoFirma: null });
                  crearListadoFad(form.getFieldsValue().nombreNuevoListado);
                }
              }}
            >
              Crear listado
            </Button>
          </>
        )}

        <Form.Item
          label="Permitir Descarga"
          name="descargar"
          valuePropName="checked"
        >
          <Switch />
        </Form.Item>

        <Form.Item
          label="Permitir Firma Digital"
          name="firmaDigital"
          valuePropName="checked"
        >
          <Switch />
        </Form.Item>
        <Form.Item
          noStyle
          shouldUpdate={(prevValues, currentValues) =>
            prevValues.firmaDigital !== currentValues.firmaDigital
          }
        >
          {({ getFieldValue }) => {
            return (
              getFieldValue("firmaDigital") && (
                <>
                  <Form.Item
                    label="Proveedor"
                    name="proveedorFirma"
                    hasFeedback
                    rules={[
                      { required: true, message: "Selecciona un proveedor" },
                    ]}
                  >
                    <Select
                      onChange={(e) => {
                        setSelectProveedor(e);
                      }}
                    >
                      <Option value="fad">Firma Autografa (FAD)</Option>
                    </Select>
                  </Form.Item>
                </>
              )
            );
          }}
        </Form.Item>

        <Form.List name="condicionales">
          {(fields, { add, remove }) => (
            <div
              style={{
                background: "rgb(237 237 237)",
                minHeight: 100,
                padding: 10,
                borderRadius: 5,
              }}
            >
              {fields.map(({ key, name, fieldKey, ...restField }, index2) => (
                <div
                  key={key}
                  style={{
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  <Form.Item
                    style={{ flex: 1, margin: 5 }}
                    hasFeedback
                    {...restField}
                    colon={false}
                    name={[name, "atributo"]}
                    fieldKey={[fieldKey, "atributo"]}
                    rules={[
                      {
                        required: true,
                        message: "Campo obligatorio",
                      },
                    ]}
                    label="Atributo"
                  >
                    <Select>
                      {store.losatributos.texts.map((atr) => {
                        return <Option value={atr.nombre}>{atr.nombre}</Option>;
                      })}
                    </Select>
                  </Form.Item>

                  <Form.Item
                    style={{ flex: 1, margin: 5 }}
                    hasFeedback
                    {...restField}
                    colon={false}
                    name={[name, "operador"]}
                    fieldKey={[fieldKey, "operador"]}
                    rules={[
                      {
                        required: true,
                        message: "Campo obligatorio",
                      },
                    ]}
                    label="operador"
                  >
                    <Select>
                      <Option value="$eq">Es Igual</Option>
                      <Option value="$ne">Es diferente</Option>
                    </Select>
                  </Form.Item>

                  <Form.Item style={{ flex: 1, margin: 5 }} shouldUpdate>
                    {({ getFieldValue }) => {
                      return (
                        getFieldValue().condicionales[index2] && (
                          <Form.Item
                            {...restField}
                            name={[name, "valor"]}
                            fieldKey={[fieldKey, "valor"]}
                            label="Valor"
                            style={{
                              flex: 1,
                            }}
                            rules={[
                              {
                                required: true,
                                message: "Campo obligatorio",
                              },
                            ]}
                          >
                            <Select>
                              {store.losatributos.texts
                                .find((at) => {
                                  return (
                                    at.nombre ===
                                    getFieldValue().condicionales[index2]
                                      .atributo
                                  );
                                })
                                .opciones.map((op, index) => {
                                  return (
                                    <Option key={"i" + index} value={op}>
                                      {op}
                                    </Option>
                                  );
                                })}
                            </Select>
                          </Form.Item>
                        )
                      );
                    }}
                  </Form.Item>
                  <FontAwesomeIcon
                    style={{
                      cursor: "pointer",
                      alignSelf: "center",
                      marginTop: 27,
                      marginLeft: 10,
                    }}
                    icon={faMinusCircle}
                    onClick={() => remove(name)}
                  />
                </div>
              ))}

              <p
                style={{
                  fontSize: 13,
                  marginBottom: 30,
                  fontWeight: 600,
                  cursor: "pointer",
                  marginTop: 10,
                  textAlign: "center",
                }}
                onClick={() => {
                  store.losatributos.texts.length > 0
                    ? add()
                    : message.error(
                        "Debe tener atributos TEXTO para crear condicionales"
                      );
                }}
              >
                + Agregar Condicional
              </p>
            </div>
          )}
        </Form.List>

        {selectProveedor == "fad" && <CamposPersonalizados form={form} />}

        <Form.Item>
          <div
            style={{
              display: "flex",
              justifyContent: "space-around",
              marginTop: 15,
            }}
          >
            <Boton loading={loading} texto="Guardar" htmlType="submit" />
            <Boton
              loading={loading}
              onClick={() => {
                props.setVisible(false);
              }}
              texto="Cancelar"
              tipo="danger"
              htmlType="button"
            />
          </div>
        </Form.Item>
      </Form>
    </div>
  );
}

export default CrearActualizarWidgetAutoLlenarPdf;
